module.exports = __webpack_public_path__ + "static/media/icon_angle_double_down.4c406618.svg";